import React from "react";
import PendingPayouts from "./PendingPayouts";
import PlatformWalletDetails from "./PlatformWalletDetails";
import { Link } from "react-router-dom/cjs/react-router-dom";

const ARDashboard = () => {
  return (
    <div className="min-h-screen">
      {/* Header Section */}
      <div className="flex items-center space-x-20 px-2 py-2">
        <Link to={"/marketingAdmin"} className="">
          <div className="flex items-center">
            <img
              src="https://w7.pngwing.com/pngs/848/762/png-transparent-computer-icons-home-house-home-angle-building-rectangle-thumbnail.png"
              className="h-6 mr-3"
              alt="home"
            />
            <h1>Home</h1>
          </div>
        </Link>
      </div>
      <PlatformWalletDetails />
      <PendingPayouts />
    </div>
  );
};

export default ARDashboard;
